import Flickity from "flickity";

const SELECTORS = {
  componentMomentQuestions: "#edit-moments-questions",
};

window.Drupal.behaviors.momentQuestions = {
  attach: (context) => {
    const ins = {};
    for (const instance in SELECTORS) {
      ins[instance] = [...context.querySelectorAll(SELECTORS[instance])];
      if (ins[instance].length) {
        for (const component of ins[instance]) {
          if (component.children.length > 1) {
            const flickity = new Flickity(component, {
              cellAlign: "center",
              draggable: false,
              wrapAround: true,
              lazyLoad: false,
              contain: true,
              pageDots: false,
              adaptiveHeight: true,
              imagesLoaded: true,
              on: {
                ready: function () {
                  
                },
                change: function (index) {
              
                  const momentQuestionContent = context.querySelectorAll("#edit-moments-questions");
                  if (momentQuestionContent) {

                    let timeLeft;
                    const momentQuestionParent = context.querySelector(".moment__question.is-selected");
                    const momentQuestionP = context.querySelector(".moment__question.is-selected").dataset.user;
                    const momentQuestionLast = context.querySelector(".moment__question.is-selected").dataset.last;
                    const base = context.querySelector(".moment__question.is-selected .moments__question--timer");
                    let nextFlickty = context.querySelector('.flickity-prev-next-button.next');
                    let continueFlickty = context.querySelector('#edit-submit');
                    // console.dir(base);

                    if (base != null) {
                      // console.log("entro");

                      // moments__question--timer--count

                      const newFieldNumber = context.createElement('p');
                      newFieldNumber.classList.add('moments__question--timer--count');
                      newFieldNumber.innerHTML = base.innerHTML;

                      momentQuestionParent.insertBefore(newFieldNumber, base);

                      // moments__question--timer--progress

                      const newFieldProgressDiv = context.createElement('div');
                      newFieldProgressDiv.classList.add('moments__question--timer--progress');
                      newFieldProgressDiv.setAttribute("role", "progressbar"); 
                      newFieldProgressDiv.setAttribute("aria-valuemin", "0"); 

                      newFieldProgressDiv.setAttribute("aria-valuenow", "100"); 
                      newFieldProgressDiv.setAttribute("style", "--value: 100"); 
                      momentQuestionParent.insertBefore(newFieldProgressDiv, newFieldNumber);  
                      

                      timeLeft = parseInt(base.innerHTML, 10);
                      let sTimeOut; 
                      function countdown() {
                        // console.log(timeLeft, base);
                        percent(timeLeft);
                        timeLeft--;
                        newFieldNumber.innerHTML = String( timeLeft );
                        if (timeLeft > 0) {
                           sTimeOut = setTimeout(countdown, 1000);
                           
                            continueFlickty.addEventListener('click', function () {
                              // console.log("Reset", timeLeft);
                              timeLeft = parseInt(base.innerHTML, 10);
                              newFieldNumber.remove();
                              newFieldProgressDiv.remove();
                              clearTimeout(sTimeOut);
                              // console.log(timeLeft);
                          });
                        } else if (momentQuestionLast === '1') {
                          nextFlickty.disabled = 'true'; // Validate
                          continueFlickty.click();
                        } else {
                          nextFlickty.click();
                          newFieldNumber.remove();
                          newFieldProgressDiv.remove();
                        }
                      };

                      setTimeout(countdown, 1000);
                      
                      function percent(timeLeft) {
                        const percent = parseInt(base.innerHTML, 10);
                        let percentTime = (timeLeft * 100) / percent;
                        let percentTemp = (100 - percentTime) + (1 * 100) / percent;
                        
                        newFieldProgressDiv.setAttribute("aria-valuemin", percentTemp); 
                        newFieldProgressDiv.setAttribute("aria-valuenow", percentTemp); 
                        newFieldProgressDiv.setAttribute("style", `--value: ${percentTemp}`);
                      }
                    }
                  
                    if (momentQuestionP === 'host') {
                      context.body.classList.add('club__moments--host');
                      context.body.classList.remove('club__moments--guest');
                      } else if (momentQuestionP === 'guest') {
                      context.body.classList.remove('club__moments--host');
                      context.body.classList.add('club__moments--guest');
                    }

                  }

                }
              }
            });

            const numberQuestion = context.querySelector('[data-drupal-selector="edit-actions"]');
            const momentQuestionDiv = context.querySelectorAll('.moment__question');

            const textCount = context.createElement("p");
            textCount.classList.add("field--name-count");
            numberQuestion.insertAdjacentElement('afterend', textCount);

            textCount.innerText = `Pregunta 1 de ${momentQuestionDiv.length}`;

            flickity.on('change', function (index) {
              textCount.innerText = `Pregunta ${index + 1} de ${momentQuestionDiv.length}`;
            });

          }
        }
      }
    }
  },
};


